module.exports = __webpack_public_path__ + "img/utoss.413cd0f0.png";